import instance from "./BasebComoApi";

export function validateComoCredentials(data) {
  return instance.request({
    url: `validate-credentials/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function getComoConfig(organisationId) {
  return instance.request({
    url: `config/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getComoStatus(organisationId, locationId=null, brandId=null) {
  return instance.request({
    url: `status/?organisation_id=${organisationId}${locationId ? `&location_id=${locationId}` : ''}${brandId ? `&brand_id=${brandId}` : ''}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function updateComo(data) {
  return instance.request({
    url: `update-credentials/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function deactivateComo(data) {
  return instance.request({
    url: `deactivate/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}
